import { value } from '@takeshape/util';
import { CURRENT_OPEN_API_TRANSFORM_VERSION } from "../constants.js";
import { updateAuthentication } from "../util/authentication.js";
import { hasEveryKey } from "../util/has.js";
import { endpointWithPath, getHealthCheck } from "../util/health.js";
const serviceProvider = {
    name: 'loyaltylion',
    title: 'Loyalty Lion',
    description: 'Access Loyalty Lion as a GraphQL API',
    categories: ['content', 'database'],
    links: [{ title: 'Homepage', url: 'https://loyaltylion.com' }],
    serviceType: 'openapi',
    introspectionType: 'openapi',
    createId: value('loyaltylion'),
    getFormSchema: value({
        type: 'object',
        properties: {
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '^[0-9a-z_-]+$',
                default: 'loyalty-lion'
            },
            title: {
                title: 'Name',
                type: 'string',
                default: 'Loyalty Lion'
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$',
                default: 'LoyaltyLion'
            },
            authentication: {
                title: 'Authentication',
                type: 'object',
                properties: {
                    username: { type: 'string', title: 'Token' },
                    password: { type: 'string', title: 'Secret' }
                },
                required: ['username', 'password']
            }
        },
        required: ['title', 'id', 'namespace', 'authentication']
    }),
    getFormConfig: value({
        order: ['title', 'id', 'namespace', 'authentication'],
        properties: {
            title: {
                widget: 'singleLineText',
                instructions: 'A human-readable title for this service.'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'A unique, url-safe identifier for this service.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A namespace to use for any generated types or queries. For example, if you enter `Foo` your types will be named `Foo_Bar`.'
            },
            authentication: {
                properties: {
                    username: {
                        widget: 'sensitiveField'
                    },
                    password: {
                        widget: 'sensitiveField'
                    }
                },
                order: ['username', 'password'],
                instructions: 'Find these values in the Loyalty Lion dashboard: [Manage → Configuration → Settings](https://app.loyaltylion.com/)'
            }
        }
    }),
    getConfig(formData) {
        const config = {
            serviceType: 'openapi',
            provider: 'loyaltylion',
            authenticationType: 'basic',
            id: formData.id ?? 'loyaltylion',
            title: formData.title ?? 'Loyalty Lion',
            namespace: formData.namespace ?? 'Loyalty',
            options: {
                endpoint: 'https://api.loyaltylion.com/v2/',
                spec: 'https://raw.githubusercontent.com/takeshape/openapi-specs/main/specs/loyaltylion/v2.yml',
                transformVersion: CURRENT_OPEN_API_TRANSFORM_VERSION
            }
        };
        return updateAuthentication(config, formData, { type: 'bearer' });
    },
    checkQueryParams: value({}),
    // For future use when OAuth supports the rewards endpoint
    // getServerAuthentication: (options): OAuth2ServerAuthentication => ({
    //   type: 'oauth2',
    //   authorizationUrl: 'https://app.loyaltylion.com/oauth/authorize',
    //   accessTokenUrl: 'https://app.loyaltylion.com/oauth/access-token',
    //   clientId: 'loyaltyLionClientId',
    //   clientSecret: 'loyaltyLionClientSecret',
    //   scope: 'write_customers,write_unsubscribes,write_orders',
    //   redirectUrl: isString(options.apiBaseUrl) ? `${options.apiBaseUrl}/oauth/loyaltylion/redirect` : ''
    // }),
    isCompleteConfig: hasEveryKey(['authentication']),
    getHealthCheck: getHealthCheck({
        checkName: 'ping',
        endpoint: endpointWithPath('/customers')
    })
};
export default serviceProvider;
